<template>
<div id="dealer-search">
  <router-view :loaded="loaded" v-if="loaded">
  </router-view>
</div>
</template>

<script>
import PrepareFilter from './utils/PrepareFilter'
import {
  i18n
}
from './plugins/i18n.js'
import {
  mapState,
} from 'vuex'

export default {
  name: 'app',
  components: {

  },
  data: function() {
    return {
      user: {},
      loaded: false,
      from: null,
      searchstring: null,
      mfilter: {}
    }
  },
  created: function() {

    const mountEl = document.querySelector('#available-vehicles');


    if (mountEl && mountEl.dataset){

    if(mountEl.dataset.lang != undefined) {
      let languages = ['de', 'en', 'fr'];
      i18n.locale = languages[mountEl.dataset.lang];
      this.language = languages[mountEl.dataset.lang];
      //this.$store.commit("setLanguage", mountEl.dataset.lang);
    }


    if(mountEl.dataset.country && mountEl.dataset.country != ''){

      let country = mountEl.dataset.country.toUpperCase();

      this.$store.commit('summery/address', null);
      this.$store.commit('summery/country', country);
      this.$store.commit('summery/fetchList', true);
        this.$router.push({
            path: '/l'
          }
        );
    }

    if(mountEl.dataset.location && mountEl.dataset.location != ''){

      let location = mountEl.dataset.location.split("/");

      this.$store.dispatch('summery/availableVehicles', {
        lat: location[0],
        lng: location[1],
        distance: location[2],
        filter: this.filter
      }).then((x)=>{
        this.$router.push({
            path: '/l'
          }
        );
      });

    }

    if(mountEl.dataset.searchstring && mountEl.dataset.searchstring != ''){
      this.searchstring = mountEl.dataset.searchstring;
      let t = this.searchstring.split("&");
      for(let index in t){
        let p = t[index].split("=");
        PrepareFilter(this.mfilter, {'name':p[0], 'operator': "=", 'value': p[1]});
      }
      this.$store.commit('summery/setFilter', this.mfilter);
      this.$store.commit('summery/fetchList', true);
      this.$router.push({
          path: '/l'
        }
      );
    }

    if (mountEl.dataset.lang != null) {
      i18n.locale = mountEl.dataset.lang;
    }

    if (mountEl.dataset.user != null) {
      this.user.id = mountEl.dataset.user;
    }

    if (mountEl.dataset.offers != null) {
      this.$store.commit('summery/showOffers', false);
    }

    if (mountEl.dataset.sec != null) {
      this.user.sec = mountEl.dataset.sec;
    }
  }


  var pathArray = window.location.pathname.split('/');
  var secondLevelLocation = pathArray[1];


    if (secondLevelLocation == "de" || secondLevelLocation == "en" || secondLevelLocation == "fr") {
      i18n.locale = secondLevelLocation;
    } else {
      i18n.locale = "de";
    }

    this.loaded = true;
  },
  methods: {


  }

}
</script>

<style>

.trike {
  min-width: 39px;
  opacity: 1 !important;
  background-repeat: no-repeat;
  transform: scale(1.2);
  padding: 3px;
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 14.0.0, SVG Export Plug-In --%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd' %5B %3C!ENTITY ns_flows 'http://ns.adobe.com/Flows/1.0/'%3E%0A%5D%3E%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:a='http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/' x='0px' y='0px' width='34px' height='14px' viewBox='0.473 0.993 34 14' enable-background='new 0.473 0.993 34 14' xml:space='preserve'%3E%3Cdefs%3E%3C/defs%3E%3Cpath fill='none' d='M30.348,13.429c-0.408-0.088-0.795-0.297-1.13-0.578C29.557,13.13,29.948,13.332,30.348,13.429z'/%3E%3Cpath fill='none' d='M29.11,12.759c-0.323-0.303-0.594-0.678-0.737-1.133C28.516,12.082,28.784,12.46,29.11,12.759z'/%3E%3Cpath fill='none' d='M4.312,11.531c-0.025-0.104-0.074-0.193-0.066-0.313C4.233,11.402,4.268,11.478,4.312,11.531z'/%3E%3Cpath fill='none' d='M32.15,8.021c2.349,1.033,1.944,4.701-0.564,5.337C34.221,12.736,34.515,9.061,32.15,8.021z'/%3E%3Cpath fill='%23000000' d='M8.84,4.244c0.119-0.463,0.362-1.109,0.349-1.512C8.881,3.258,8.485,3.695,8.199,4.244 C8.413,4.244,8.625,4.244,8.84,4.244z'/%3E%3Cpath fill='%23000000' d='M23.198,3.895c0.215-0.229,0-0.687-0.232-0.813C22.973,3.211,23.044,3.724,23.198,3.895z'/%3E%3Cpath fill='%23000000' d='M23.606,4.417c0.496,0.415,1.5,0.63,1.977,0.873C25.182,4.779,24.315,4.428,23.606,4.417z'/%3E%3Cpath fill='%23FFFFFF' d='M25.059,5.697c0.161-0.091,0.271-0.234,0.406-0.059c0.041-0.311-0.174-0.366-0.35-0.464 C25.168,5.385,24.864,5.535,25.059,5.697z'/%3E%3Cpath fill='%23FFFFFF' d='M12.734,5.697c-0.126-0.205-0.652-0.314-0.873-0.232C12.144,5.552,12.425,5.639,12.734,5.697z'/%3E%3Cpath fill='%23FFFFFF' d='M27.266,7.73c0.193,0.043,0.529,0.318,0.582,0C27.579,7.77,27.435,7.471,27.266,7.73z'/%3E%3Cpath fill='%23FFFFFF' d='M27.209,8.429c0.115-0.116,0.275-0.188,0.35-0.349c-0.146-0.048-0.313-0.076-0.523-0.059 C27.075,8.178,27.127,8.318,27.209,8.429z'/%3E%3Cpath fill='%23FFFFFF' d='M25.814,9.01c0.175,0,0.35,0,0.524,0C26.322,8.757,25.899,8.959,25.814,9.01z'/%3E%3Cpath fill='%23FFFFFF' d='M30.873,9.126c-0.3-0.042-0.465,0.277-0.407,0.408C30.67,9.669,30.955,9.466,30.873,9.126z'/%3E%3Cpath fill='%23FFFFFF' d='M31.221,9.126c0,0.115,0,0.232,0,0.35c0.316,0.033,0.543,0.328,0.871,0.174 C31.97,9.306,31.646,9.167,31.221,9.126z'/%3E%3Cpath fill='%23FFFFFF' d='M25.872,9.998c0.032-0.297,0.104-0.555,0.232-0.756c-0.258,0.012-0.394,0.15-0.521,0.293 C25.739,9.628,25.625,9.994,25.872,9.998z'/%3E%3Cpath fill='%23FFFFFF' d='M25.116,9.708c-0.289,0.02-0.476,0.143-0.813,0.117c-0.233,0.248-0.396,0.57-0.64,0.813 c-0.412-0.018-1.146,0.234-0.93,0.465c1.018,0.068,2.118,0.309,2.85-0.117C25.492,10.498,25.228,10.177,25.116,9.708z'/%3E%3Cpath fill='%23FFFFFF' d='M32.442,10.871c0.132-0.307,0.024-0.824-0.175-0.99C32.054,10.107,32.313,10.625,32.442,10.871z'/%3E%3Cpath fill='%23FFFFFF' d='M3.375,10.23c0.341,0.078,0.632,0.174,0.871-0.057C3.93,10.248,3.534,9.951,3.375,10.23z'/%3E%3Cpath fill='%23FFFFFF' d='M25.292,11.335c0.258-0.043,0.535,0.197,0.697,0.059c-0.234,0.041-0.143-0.244-0.35-0.232 C25.565,11.261,25.292,11.164,25.292,11.335z'/%3E%3Cpath fill='%23FFFFFF' d='M31.686,11.859c0.26,0.027,0.549-0.418,0.698-0.697C32.066,11.308,31.924,11.634,31.686,11.859z'/%3E%3Cpath fill='%23FFFFFF' d='M30.408,12.033c0.243,0.029,0.847,0.182,0.987-0.057C31.053,11.996,30.461,11.603,30.408,12.033z'/%3E%3Cpath fill='%23FFFFFF' d='M27.5,7.904c-0.19-0.106-0.627-0.15-0.697-0.057C26.952,7.915,27.424,7.957,27.5,7.904z'/%3E%3Cpath fill='%23FFFFFF' d='M29.592,11.218c0.093,0.297,0.309,0.469,0.523,0.641C30.26,11.513,29.706,11.49,29.592,11.218z'/%3E%3Cpath fill='none' d='M0.062,0c-0.067,0.01-0.064,0.092-0.06,0.174c0,5.408,0,10.812,0,16.218c11.667,0,23.333,0,34.999,0 C35,10.929,35,5.465,35,0C23.352,0,11.707,0,0.062,0z M31.585,13.359c-0.368,0.086-0.779,0.117-1.237,0.07 c-0.4-0.098-0.791-0.299-1.13-0.578c-0.036-0.027-0.071-0.061-0.108-0.092c-0.326-0.299-0.594-0.678-0.737-1.133 c-0.12-0.131-0.338-0.166-0.465-0.291c-0.161-1.014,0.104-2,0.522-2.615c0.018-0.443-0.305-0.549-0.64-0.641 c-0.276,0.052-0.312,0.347-0.581,0.408c0.273,0.152,0.033,0.453,0.057,0.697c-0.913-0.033-1.506,1.104-1.103,1.861 c0.685,0.203,0.914,0.867,1.859,0.813c-0.343,0.652-0.96,0.684-1.859,0.639c-1.558-0.076-3.465-0.535-5.175-0.465 c-0.904,0.037-1.677,0.045-2.383,0c-0.217-0.043-0.126,0.225-0.29,0.232c-0.861-0.213-1.932-0.082-2.733-0.232h-0.291 c-1.56,0.047-3.247,0.27-4.372,0.561c-0.285,0.059-0.123-0.07-0.502-0.232c-0.101-0.791-0.706-1.641-0.817-1.498 c-0.751,0.949-0.375-1.494-2.213-1.555c-2.752,0.117-2.635,3.518-2.85,2.551c-0.049-0.223-0.155-0.244-0.226-0.328 c-0.044-0.053-0.079-0.129-0.066-0.313c-0.295-0.002-0.481,0.102-0.813,0.061c-0.484-0.904-1.771-0.41-2.383-1.105 c0.641-0.979-0.65-1.785-0.117-2.964c0.293-0.145,0.527-0.353,0.815-0.35C1.725,6.392,1.832,6.054,1.863,5.639 C2.024,5.566,2.158,5.47,2.387,5.465c-0.222-0.114-0.023-0.531,0.115-0.64c-0.438-0.24-0.81-0.547-0.813-1.222 c1.028-0.209,1.797,0.334,2.849,0.291c0.081,0.112,0.153,0.234,0.175,0.407c1.022-0.023,1.938-0.155,3.021-0.117 C8.341,3.551,8.611,2.58,9.421,2.15C9.435,1.914,9.51,1.737,9.653,1.627c0.19-0.015,0.28,0.069,0.291,0.232 c0.055-0.364,0.402-0.381,0.697-0.232c0.275,0.387,0.41,1.538-0.407,1.454C10.024,2.982,9.992,2.705,9.886,2.5 C9.657,2.987,9.674,3.723,9.479,4.244c0.064,0.188,0.405,0.099,0.581,0.173c-0.015-0.86,1.367-0.571,1.395,0.233 C12.14,4.496,12.723,4.93,13.374,5c0.303,0.381,1.12,1.242,0.407,1.744c-0.085-0.418-0.156-0.852-0.407-1.105 c-0.137-0.002-0.172,0.1-0.35,0.059c0.356,0.225,0.43,0.733,0.524,1.221C14.07,6.953,14.667,6.609,15,6.977c0,0.135,0,0.271,0,0.406 c0.025,0.133,0.341-0.031,0.234,0.232c0.354,0.045,0.527-0.092,0.871-0.058c-0.476-0.282-0.796-2.175,0.06-2.093 c-0.06-0.369,0.089-0.531,0.29-0.64c0.659,0.388,0.84,1.254,1.105,2.034c0.712,0.509,1.367,1.074,1.859,1.802 c0.557-0.077,1.564-0.776,1.861-0.058c0.643-0.708,1.18-1.651,1.977-2.034c-0.09-0.278-0.497-0.239-0.465-0.641 c0.051-0.045,0.131-0.063,0.232-0.058c0.201,0.071,0.229,0.314,0.291,0.523C23.84,6.298,24.357,5.932,25,6.221 c-0.069-0.357-0.48-0.374-0.756-0.523c0.082-0.227,0.139-0.481,0.29-0.64c-0.273-0.191-0.649-0.278-0.872-0.523 c-0.356,0.245-0.745,0.094-1.104,0.116c-0.07-0.09-0.188-0.227-0.059-0.349c-0.23-0.002-0.521,0.058-0.523-0.175 c0.175-0.207,0.613-0.417,0.931-0.289c0.046-0.29,0.019-0.328-0.058-0.582c-0.175,0.084-0.404,0.213-0.407-0.116 c-0.135,0.059-0.188,0.2-0.408,0.174c-0.117-0.191-0.067-0.626,0.06-0.756c0.336-0.048,0.377,0.35,0.465-0.058 c0.223,0.125,0.285,0.412,0.639,0.407c0.023,0.365,0.279,0.495,0.234,0.931c0.84,0.286,2.209,0.536,2.614,1.452 c0.657-0.224,1.104,0.702,1.513,1.104c0.089-0.202,0.24-0.341,0.406-0.466c0.521-0.075,0.774,0.118,1.105,0.233 c0.126,0.273,0.026,0.638-0.059,0.872c-0.075,0.08-0.253,0.058-0.408,0.058c-0.092,0.576,0.283,0.687,0.523,0.93 c0.697-0.618,2.529-0.593,3.372-0.117c-0.007,0.15-0.194,0.115-0.35,0.117C34.515,9.061,34.221,12.736,31.585,13.359z'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' fill='%23FFFFFF' d='M7.543,8.524c-1.718,0-3.109,1.393-3.109,3.11 c0,1.719,1.392,3.111,3.109,3.111c1.717,0,3.111-1.393,3.111-3.111C10.655,9.917,9.261,8.524,7.543,8.524z M7.526,12.556 c-0.437,0-0.791-0.377-0.791-0.844s0.354-0.844,0.791-0.844c0.436,0,0.79,0.377,0.79,0.844S7.961,12.556,7.526,12.556z'/%3E%3Cpath fill='%23FFFFFF' d='M32.15,8.021c0.155-0.002,0.343,0.033,0.35-0.117c-0.843-0.476-2.675-0.501-3.372,0.117 c-0.24-0.243-0.615-0.354-0.523-0.93c0.155,0,0.333,0.022,0.408-0.058c0.085-0.234,0.185-0.599,0.059-0.872 c-0.331-0.115-0.585-0.309-1.105-0.233c-0.166,0.125-0.317,0.264-0.406,0.466c-0.408-0.402-0.855-1.328-1.513-1.104 c-0.405-0.916-1.774-1.166-2.614-1.452c0.045-0.436-0.211-0.565-0.234-0.931c-0.354,0.005-0.416-0.282-0.639-0.407 c-0.088,0.407-0.129,0.01-0.465,0.058c-0.127,0.13-0.177,0.564-0.06,0.756c0.22,0.026,0.273-0.115,0.408-0.174 c0.003,0.329,0.232,0.2,0.407,0.116c0.076,0.254,0.104,0.292,0.058,0.582C22.59,3.71,22.152,3.92,21.977,4.127 C21.979,4.359,22.27,4.3,22.5,4.302c-0.129,0.122-0.012,0.259,0.059,0.349c0.358-0.022,0.747,0.129,1.104-0.116 c0.223,0.245,0.599,0.332,0.872,0.523c-0.151,0.158-0.208,0.413-0.29,0.64C24.52,5.847,24.931,5.863,25,6.221 c-0.644-0.289-1.16,0.077-1.686,0.174c-0.063-0.209-0.09-0.452-0.291-0.523c-0.102-0.006-0.182,0.013-0.232,0.058 c-0.032,0.401,0.375,0.362,0.465,0.641c-0.797,0.383-1.334,1.326-1.977,2.034c-0.297-0.719-1.304-0.02-1.861,0.058 c-0.492-0.728-1.147-1.293-1.859-1.802c-0.265-0.78-0.446-1.646-1.105-2.034c-0.201,0.108-0.349,0.271-0.29,0.64 c-0.855-0.082-0.536,1.811-0.06,2.093c-0.344-0.034-0.517,0.103-0.871,0.058c0.107-0.264-0.209-0.1-0.234-0.232 c0-0.135,0-0.271,0-0.406c-0.334-0.367-0.931-0.023-1.453-0.059c-0.094-0.487-0.167-0.996-0.524-1.221 c0.178,0.041,0.213-0.061,0.35-0.059c0.25,0.254,0.321,0.688,0.407,1.105C14.494,6.242,13.677,5.381,13.374,5 c-0.65-0.07-1.233-0.504-1.919-0.35c-0.027-0.805-1.409-1.094-1.395-0.233C9.884,4.343,9.543,4.432,9.479,4.244 C9.674,3.723,9.657,2.987,9.886,2.5c0.106,0.205,0.139,0.482,0.349,0.581c0.817,0.084,0.682-1.067,0.407-1.454 c-0.295-0.148-0.642-0.132-0.697,0.232C9.934,1.696,9.843,1.612,9.653,1.627C9.51,1.737,9.435,1.914,9.421,2.15 c-0.81,0.43-1.08,1.4-1.687,2.034C6.651,4.146,5.735,4.278,4.713,4.302C4.691,4.129,4.619,4.007,4.538,3.895 c-1.052,0.043-1.821-0.5-2.849-0.291c0.003,0.675,0.375,0.981,0.813,1.222c-0.138,0.108-0.337,0.525-0.115,0.64 C2.158,5.47,2.024,5.566,1.863,5.639C1.832,6.054,1.725,6.392,1.748,6.859c-0.288-0.003-0.522,0.205-0.815,0.35 c-0.533,1.18,0.758,1.986,0.117,2.964c0.613,0.695,1.899,0.201,2.383,1.105c0.333,0.041,0.519-0.063,0.813-0.061 c-0.008,0.119,0.041,0.209,0.066,0.313c0.071,0.084,0.177,0.105,0.226,0.328c0.214,0.967,0.097-2.434,2.85-2.551 c1.838,0.061,1.462,2.504,2.213,1.555c0.111-0.143,0.716,0.707,0.817,1.498c0.38,0.162,0.217,0.291,0.502,0.232 c1.125-0.291,2.813-0.514,4.372-0.561h0.291c0.801,0.15,1.872,0.02,2.733,0.232c0.163-0.008,0.073-0.275,0.29-0.232 c0.707,0.045,1.479,0.037,2.383,0c1.71-0.07,3.617,0.389,5.175,0.465c0.899,0.045,1.517,0.014,1.859-0.639 c-0.945,0.055-1.175-0.609-1.859-0.813c-0.403-0.758,0.189-1.895,1.103-1.861c-0.023-0.244,0.217-0.544-0.057-0.697 c0.27-0.062,0.305-0.356,0.581-0.408c0.335,0.092,0.657,0.197,0.64,0.641c-0.418,0.615-0.684,1.601-0.522,2.615 c0.127,0.125,0.345,0.16,0.465,0.291c0.144,0.455,0.414,0.83,0.737,1.133c0.037,0.031,0.072,0.064,0.108,0.092 c0.335,0.281,0.722,0.49,1.13,0.578c0.458,0.047,0.869,0.016,1.237-0.07C34.094,12.722,34.499,9.055,32.15,8.021z M23.198,3.895 c-0.153-0.171-0.225-0.684-0.232-0.813C23.198,3.208,23.413,3.666,23.198,3.895z M3.375,10.23c0.158-0.279,0.555,0.018,0.871-0.057 C4.008,10.404,3.716,10.308,3.375,10.23z M8.84,4.244c-0.215,0-0.427,0-0.641,0c0.286-0.549,0.682-0.986,0.989-1.512 C9.202,3.135,8.958,3.781,8.84,4.244z M11.862,5.465c0.221-0.082,0.746,0.027,0.873,0.232C12.425,5.639,12.144,5.552,11.862,5.465z M23.606,4.417c0.709,0.011,1.576,0.362,1.977,0.873C25.106,5.047,24.102,4.832,23.606,4.417z M25.465,5.639 c-0.135-0.176-0.245-0.032-0.406,0.059c-0.195-0.162,0.109-0.313,0.057-0.522C25.292,5.272,25.506,5.328,25.465,5.639z M22.733,11.103c-0.217-0.23,0.518-0.482,0.93-0.465c0.243-0.242,0.406-0.564,0.64-0.813c0.338,0.025,0.524-0.098,0.813-0.117 c0.112,0.469,0.376,0.789,0.467,1.277C24.851,11.412,23.75,11.171,22.733,11.103z M25.292,11.335c0-0.172,0.273-0.074,0.348-0.174 c0.207-0.012,0.115,0.273,0.35,0.232C25.827,11.533,25.549,11.292,25.292,11.335z M25.872,9.998 c-0.246-0.004-0.133-0.369-0.289-0.463c0.128-0.143,0.264-0.281,0.521-0.293C25.975,9.443,25.904,9.701,25.872,9.998z M25.814,9.01 c0.085-0.051,0.508-0.253,0.524,0C26.164,9.01,25.989,9.01,25.814,9.01z M27.5,7.904c-0.076,0.053-0.549,0.011-0.697-0.057 C26.874,7.754,27.31,7.798,27.5,7.904z M27.209,8.429c-0.082-0.11-0.135-0.251-0.174-0.407c0.211-0.018,0.378,0.011,0.523,0.059 C27.485,8.24,27.325,8.313,27.209,8.429z M27.266,7.73c0.169-0.26,0.313,0.039,0.582,0C27.795,8.049,27.459,7.773,27.266,7.73z M32.442,10.871c-0.002-0.002-0.002-0.004-0.004-0.008c-0.015,0.104-0.027,0.207-0.061,0.303c0.003,0,0.003-0.002,0.007-0.004 c-0.002,0.002-0.007,0.008-0.009,0.01c-0.214,0.605-0.773,1.043-1.451,1.043c-0.859,0-1.554-0.695-1.554-1.557 c0-0.859,0.694-1.553,1.554-1.553c0.106,0,0.197,0.039,0.297,0.059c0-0.012,0-0.025,0-0.037c0.364,0.033,0.627,0.17,0.777,0.416 c0.025,0.021,0.043,0.051,0.066,0.076c0.005,0.012,0.023,0.018,0.027,0.031c-0.001,0.002-0.003-0.002-0.006,0 c0.07,0.082,0.126,0.17,0.178,0.264C32.27,9.906,32.26,9.89,32.267,9.88c0.03,0.025,0.038,0.094,0.063,0.131 c0.012,0.025,0.022,0.045,0.035,0.072c0.073,0.146,0.103,0.299,0.097,0.488c0.001,0.029,0.019,0.055,0.019,0.086 c0,0.063-0.028,0.115-0.036,0.178C32.44,10.845,32.447,10.861,32.442,10.871z'/%3E%3Cellipse fill='%23FFFFFF' cx='30.873' cy='10.658' rx='0.606' ry='0.66'/%3E%3Cpolygon fill='%23FFFFFF' points='29.292,9.236 30.397,10.447 31.083,10.238 29.661,8.709 '/%3E%3C/svg%3E%0A");
}

select.form-control {
    margin-top: 0px;
    border-radius: 4px;
    border: 1px solid #949494;
    background-color: #eee;
    height: 38px;
}

input.form-control {
  border-radius: 4px;
  border: 1px solid #949494;
  background-color: #eee;
  height: 38px;
}

.large-trikelist {
    margin-top: 20px;
}

.byellow{
  background-color: #FFEB3B!important;
}
.bbrown{
  background-color: rgb(109, 76, 65)!important;
}
.bbeige{
  background-color: #FDEBD0!important;
}
.bblue{
  background-color: #1A5276!important;
}
.bgold{
  background: linear-gradient(180deg,#d39a11,#f6d308 100%,#d39a11) #d39a11!important;
}
.bsilver{
  background: linear-gradient(180deg,#b5b5b5,#f6f6f6 100%,#ccc) #b5b5b5!important;
}
.bgrey{
  background-color: #9E9E9E!important;
}
.bgreen{
  background-color: #43A047!important;
}
.borange{
  background-color: #FF9800!important;
}
.bred{
  background-color: #F44336!important;
}
.bblack{
  background-color: #000000!important;
}
.bpurple{
  background-color: #7B1FA2!important;
}

.button{
  border-radius: 0px!important;

}
input:focus {
    outline: none !important;
    box-shadow: none !important;
}

.search-result-header {
    background-color: #efefef;
    padding-top: 10px;
    padding-bottom: 10px;
    min-height: 70px;
}

.large-trikebox {
    margin-bottom: 20px;
    border: 1px solid #eeeeee;
    border-color: #d6d6d6 !important;
    background-color: #f7f7f7;
}

.ui.input>input {
  padding: .67857143em 0.7em !important;
}

.ui.label {

  padding: 0.4em;
  background-color: #f7f7f7;
}

.ui.tag.label:before, .ui.tag.labels .label:before {

    width: 1.08em;
    height: 1.08em;
}

.ui.tag.label, .ui.tag.labels .label {
    border-radius: 0 .18571429rem .18571429rem 0;
}

a{
  color: #c51a1b;
}
a:hover{
  color: #c51a1b;
  cursor:pointer;
}
.service-lable {
    color: black;
    font-family: Anton,sans-serif;
    margin-right: 5px;
    font-size: 0.74em;
    letter-spacing: 1px;
    display: inline-block;
    min-width: 96px;
    cursor: auto;
    white-space: nowrap;
    overflow: hidden;
    text-align: left;
    padding-left: 4px;
    text-overflow: ellipsis;
}

h1, h2, h3{
  font-family: Anton,sans-serif;
letter-spacing: 1px;
text-transform: uppercase;
font-weight: 500;
line-height: 1.1;
color:black;
}

.content-top-btn {
    background-color: #c51a1b;
    position: fixed;
    width: 50px;
    height: 50px;
    bottom: 0;
    right: 0;
    z-index: 999;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity .3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.large-trikebox{
  height: 100%;
  margin-bottom: 0px;
}

.rcontainer {
  min-height: 190px;
}

.vcomponent{
  min-height: 262px;
  margin-bottom: 20px;
}

.rservices{
  float: right;
}

.listsubmenu{
    margin-bottom: 10px;
    margin-top: 10px;
}

.ad-nr{
  margin-top: 12px;
  text-align: right;
}

.vue-slider-dot {
    z-index: 2!important;
}


@media only screen and (max-width: 1000px) {

  .rcontainer {
    min-height: 0px;
  }
  .rservices{
    float: right;
  }
  .vcomponent{
    min-height: 280px;
  }

}

@media only screen and (max-width: 772px) {
  .rcontainer {
    min-height: 0px;
  }
  .rservices{
    float: left;
    width: 100%;
  }
  .vcomponent{
    min-height: 622px;
  }
  .listsubmenu{
      margin-top: 18px;
  }
  .ad-nr{
    text-align: left;
  }

}

.inset{
  margin-left: 15px;
  margin-right: 15px;
}

.service-lable {
           color: black;
           font-family: Anton,sans-serif;
           margin-right: 5px;
           font-size: 0.74em;
           letter-spacing: 1px;
           display: inline-block;
           min-width: 96px;
           cursor: auto;
           white-space: nowrap;
           overflow: hidden;
           text-align: left;
           padding-left: 4px;
           text-overflow: ellipsis;
       }

       @media only screen and (max-width: 790px) {
           .ap{
               float:right;
               margin-bottom: 5px;
           }
           .aq{
               text-align: left;
           }
       }

       .owl-nav i {
           font-size: 30px;
            background-color: #c51a1b !important;
           color: white;
           width: 100%;
           height: 100%;

       }
       .owl-nav i:before {
         margin-top: 0px;
         padding-top: 0px;
         padding-bottom: 0px;
       }
       .owl-nav {

           margin: 0px;

       }

       .owl-dots {
           margin: 15px 0 0 0;
           transform: none;
           text-align: center;
       }


       .owl-prev {
           color: #FFF;
           background: none !important;
           margin-left: 0px!important;
       }


       .owl-next {
           color: #FFF;
           background: none !important;
           margin-right: -3px !important;
       }

       .owl-theme .owl-dots .owl-dot.active span, .owl-theme .owl-dots .owl-dot:hover span {
           background: #c51a1b!important;
       }

       .ui.icon.input>i.icon {

         width: 1.3em;
       }


       .ui.message {
           position: relative;
           min-height: 1em;
           margin: 1em 0;
           background: #f8f8f9;
           padding: 1em 1.5em;
           line-height: 1.4285em;
           color: rgba(0,0,0,.87);
           -webkit-transition: opacity .1s ease,color .1s ease,background .1s ease,-webkit-box-shadow .1s ease;
           transition: opacity .1s ease,color .1s ease,background .1s ease,-webkit-box-shadow .1s ease;
           transition: opacity .1s ease,color .1s ease,background .1s ease,box-shadow .1s ease;
           transition: opacity .1s ease,color .1s ease,background .1s ease,box-shadow .1s ease,-webkit-box-shadow .1s ease;
           border-radius: .28571429rem;
           -webkit-box-shadow: 0 0 0 1px rgba(34,36,38,.22) inset, 0 0 0 0 transparent;
           box-shadow: 0 0 0 1px rgba(34,36,38,.22) inset, 0 0 0 0 transparent;
       }
</style>
